import { css } from 'styled-components';

export default {
    small: (args) => css`
            @media (max-width: 767px) {
                ${args};
            }
        `,
    medium: (args) => css`
            @media (max-width: 1199px) {
                ${args};
            }
        `,
    large: (args) => css`
            @media (min-width: 1200px) {
                ${args};
            }
        `,
};


// WEBPACK FOOTER //
// ./src/utils/styles/theme/mediaQueries.style.js